import { useState } from "react";

import { STATE_RULES, initPasswordRules } from "../constants";

const useValidateRules = (initRules = initPasswordRules) => {
  const [rules, setRules] = useState(initRules);

  const validateRule = (item) => {
    const newRules = rules.map((r) => {
      const state = r.validation(item) ? STATE_RULES.DONE : STATE_RULES.WRONG;
      return { ...r, state };
    });
    setRules(newRules);
  };

  const restoreRules = () => setRules([...initRules]);

  return [validateRule, rules, restoreRules];
};

export default useValidateRules;
